

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import $ from 'jquery'



import css from './style/css/public.css'
import animate from './style/css/animate.css'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import axios from 'axios'
import qs from 'qs'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import VueAxios from 'vue-axios'

import 'lib-flexible'
import 'es6-promise/auto'
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css'
import VueClipboard from 'vue-clipboard2'

require('vue2-animate/dist/vue2-animate.min.css');
import 'swiper/dist/css/swiper.css'

import '../static/utf8-jsp/ueditor.config.js'
import '../static/utf8-jsp/ueditor.all.min.js'
import '../static/utf8-jsp/lang/zh-cn/zh-cn.js'
import '../static/utf8-jsp/ueditor.parse.min.js'

import MetaInfo from 'vue-meta-info'
import VueTouch from 'vue-touch'
function source(){
if (/(micromessenger)/i.test(navigator.userAgent)) {

if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){

return true
}else{
return true

}
} else {
return false
}
}

Vue.use(VueTouch, {name: 'v-touch'});
Vue.use(VueClipboard);

Vue.use(VueAxios, axios)
Vue.use(ViewBox)
Vue.use(Swiper)
Vue.use(SwiperItem)
Vue.use(Tab)
Vue.use(TabItem)
Vue.use(VueAwesomeSwiper)
Vue.use(Share)

Vue.use(MetaInfo)
Vue.config.productionTip = false;
Vue.prototype.isWechat = source();


axios.defaults.baseURL = 'https://www.thinkuprep.com/';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8/';


axios.defaults.transformRequest = [function (data) {
return qs.stringify(data)
}]
axios.defaults.timeout = 5000

axios.defaults.crossDomain = true;


router.beforeEach((to, from, next) => {
/!* 路由发生变化修改页面title *!/
if (to.name === 'infoDownload') {

document.title = to.meta.title;
document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords);
document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description);
}
next();
})


router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
console.log('to.meta.keywords', to.meta.keywords);

next();
});


/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: {App},
css,
$,
template:
'<App/>',
render: h => h(App),

})



// WEBPACK FOOTER //
// ./src/main.js